module.exports = __webpack_public_path__ + "img/main-new.eba7ac11.jpg";